import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/auth/authStore';
import Splash from '@/components/splash';

export default function ProtectedRoute({ meta, children }) {
  const { loading, authenticated, forbidden, hasAccess } = useAuthStore();

  if (loading) return <Splash />;

  // Public page
  if (meta?.public) return children;

  // Requires auth
  if (meta?.auth !== false && !authenticated) return <Navigate to="/login" replace />;

  // Forbidden check
  if (forbidden) return <Navigate to="/403" replace />;

  // access checks
  if (!hasAccess(meta?.roles, meta.permissions, meta?.rolesAny, meta?.permissionsAny, meta?.userType)) return <Navigate to="/403" replace />;

  return children;
}
